import { cn } from "@/lib/utils";

interface MessageProps {
  content: string;
  isBot: boolean;
  className?: string;
}

export const Message = ({ content, isBot, className }: MessageProps) => {
  // Function to convert **text** to bold using spans
  const formatContent = (text: string) => {
    // Split by **
    const parts = text.split('**');
    return parts.map((part, index) => {
      // Even indices are normal text, odd indices are bold
      if (index % 2 === 1) {
        return <strong key={index} className="font-bold">{part}</strong>;
      }
      return part;
    });
  };

  return (
    <div
      className={cn(
        "flex w-full mb-4 message-appear",
        isBot ? "justify-start" : "justify-end",
        className
      )}
    >
      <div
        className={cn(
          "max-w-[80%] rounded-2xl px-4 py-2 whitespace-pre-line",
          isBot
            ? "bg-secondary text-secondary-foreground rounded-tl-sm"
            : "bg-primary text-primary-foreground rounded-tr-sm"
        )}
      >
        {formatContent(content)}
      </div>
    </div>
  );
};